export const getContacto = (values) => ({
    correo_electronico: values.correoElectrónico,
    celular: values.numeroCelular,
    numero_fijo: values.teléfono,
    telefono_allegado:values.teléfonoFamiliar ,
    pagina_web: values.paginaWeb,
  });
